<div id="topics" class="lg:pt-[15rem] md:pt-[10rem] pt-[6rem] xl:pt-[20rem] pb-20 text-center relative bg-[#F5EFFF]">
  <svg class="absolute top-[-5%] left-0 w-full" viewBox="0 0 1440 320" fill="none" preserveAspectRatio="none">
    <path
      fill="#ffffff"
      fill-opacity="1"
      d="M0,160 C120,100 240,80 360,100 C480,120 600,180 720,200 C840,220 960,180 1080,160 C1200,140 1320,160 1440,180 L1440,0 L0,0 Z"></path>
  </svg>
  <div class="container mx-auto px-5 md:px-[3rem] lg:px-[4rem] xl:px-[15rem]">
    <h1 class="xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-bold mb-12">Explore our other study tools</h1>

    <div class="flex flex-wrap justify-center gap-10">
      <div class="flex flex-col items-center gap-2 relative">
        <img src="Icons/star.png" alt="star" class="absolute w-8 top-0 z-0 -left-4 pointer-events-none" />
        <h3 class="text-lg font-bold relative z-10">Revision Notes</h3>
      </div>

      <div class="flex flex-col items-center gap-2 relative">
        <img src="Icons/star.png" alt="star" class="absolute w-8 top-0 z-0 -left-4 pointer-events-none" />
        <h3 class="text-lg font-bold relative z-10">Exam Questions</h3>
      </div>

      <div class="flex flex-col items-center gap-2 relative">
        <img src="Icons/star.png" alt="star" class="absolute w-8 top-0 z-0 -left-4 pointer-events-none" />
        <h3 class="text-lg font-bold relative z-10">Flash Cards</h3>
      </div>

      <div class="flex flex-col items-center gap-2 relative">
        <img src="Icons/star.png" alt="star" class="absolute w-8 top-0 z-0 -left-4 pointer-events-none" />
        <h3 class="text-lg font-bold relative z-10">Past Papers</h3>
      </div>
    </div>
  </div>
</div>
